import axios from 'axios'
import { store } from '../store'
import { router } from '@/router/router'

const service = axios.create({
    timeout: 30000 // timeout은 개발 간 용의하게 하기 위해 30초로 설정
})

// axios의 reqeust 인터셉터 진행 부
service.interceptors.request.use(
    config => {
        // 해더 가공이 필요할 경우는 여기에 정의...
        /**
        config.headers['X-LOGKEY'] = logKey
        config.headers['X-CHANNEL'] = channel
        */
        store.dispatch('SetShowCheck', true)
        return config
    }, error => {
        // TODO: timeout이나, API 접속이 안되는 에러는 여기서 정의하세요...
        return Promise.reject(error)
    }
)

// axios의 response 인터셉터
service.interceptors.response.use(
    response => {
        // console.log(response)
        let result = {
            success: false,
            msgCd: 'SUCCESS',
            msg: '',
            data: response.data
        }
        // 공통으로 response 부분을 조작할 경우 여기에 정의...
        // console.log('response', response)
        // if (response.data.dsRsinfo.msgCd === 'FAIL') {}
        store.dispatch('SetShowCheck', false)
        return result
    }, error => {
        // console.log('err', error, error.message, error.response) // for debug
        
        // TODO: API 에러 발생시 처리하는 부분은 여기에 정의하세요...
        // if(parseInt(error.response.status/100) === 5) {
        //     router.replace({
        //         name: 'Error',
        //         props: true,
        //         params: {
        //           message:
        //             '현재 서비스 장애로 인하여 접속이 원할하지 않습니다.\n잠시 후에 다시 접속해 주시기 바랍니다.',
        //           type: 'access'
        //         }
        //     })
        // }
        if(parseInt(error.response.status) === 403 ||  parseInt(error.response.status) === 404) {
            router.replace({
                name: 'NotFound',
                // props: true,
                // params: {
                //     status:
                //     error.response.status
                // }
            })
        }
        let result = {
            success: false,
            msgCd: 'FAIL',
            msg: error.message,
            data: error.response
        }
        // 에러메세지가 없을 경우 기본 에러메세지 출력
        let errorMessage = error.response.data.message
        if (!errorMessage) {
            errorMessage = error.message
        }
        store.dispatch('SetShowCheck', false)
        store.dispatch('SetErrorMsg', errorMessage)
        store.dispatch('ShowErrorConfirm')
        return Promise.reject(result)
    }
)  

export default service